import { useState } from 'react';
import cn from 'classnames';

import { getColor } from 'js/utils/np-colors';
import doAndWait from 'js/utils/do-and-wait';

import Button from 'components/button/Button';
import Image from 'components/image/Image';
import Shape from 'components/nysgjerrigper/shape/Shape';

import { IStepsBlock } from 'source/NFR.types';

interface StepsBlockProps extends IStepsBlock {
  stepIndex: number;
}

const StepsBlock: React.FC<StepsBlockProps> = ({ pages, stepIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animateLeft, setAnimateLeft] = useState(false);
  const [removeTransition, setRemoveTransition] = useState(false);

  const nextPage = async () => {
    if (animateLeft || removeTransition) return;
    await doAndWait(() => setAnimateLeft(true), 500);

    requestAnimationFrame(() => {
      setCurrentIndex(i => (i + 1) % pages.length);
      setRemoveTransition(true);
      setAnimateLeft(false);
      requestAnimationFrame(() => setRemoveTransition(false));
    });
  };

  const currentAndNextPage = [pages[currentIndex], pages[(currentIndex + 1) % pages.length]].filter(page => !!page);

  return (
    <>
      <Shape className="steps-block--snake" type="snakeH" color={getColor(stepIndex)} />
      <div className="steps-block-list">
        {currentAndNextPage?.map(({ title, text, buttonText, image }, index) => {
          const pageNumber = ((index + currentIndex) % pages.length) + 1;
          return (
            <div
              className={cn('steps-block', {
                '-animate-left': animateLeft,
                '-remove-transition': removeTransition
              })}
              key={title}
            >
              <div className="steps-block--content">
                <h2 className="steps-block--content-title">
                  <span className="steps-block--content-page-number">{`${pageNumber}/${pages.length}`}</span>
                  {title}
                </h2>
                <p className="steps-block--content-paragraph">{text}</p>
                <div className="steps-block--content-button-container">
                  <Button
                    className="steps-block--content-button"
                    theme={['primary', 'large']}
                    onClick={() => void nextPage()}
                    disabled={pageNumber !== currentIndex + 1}
                  >
                    {buttonText}
                  </Button>
                </div>
              </div>
              <div className="steps-block--image">
                <Image {...image} responsive={false} />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

StepsBlock.displayName = 'StepsBlock';

export default StepsBlock;
